import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('unstructured'),
  titleToNamespace: true,
  avatarPath: avatars.unstructured,
  logoPath: logos.unstructured
});
